import { UIViewController } from "./connector/UIViewController";
import SceneRender from "./components/SceneRender/SceneRender";
import { ScenesContext } from "./hook";
import React, { useEffect, useRef } from "react";
import { ScenesViewModel } from "@viewModels/scenes/ScenesViewModel";
import TranslationEditScene from "@scenes/TranslationEditScene/TranslationEditScene";
import { SceneControllerTranslationEdit } from "@scenes/TranslationEditScene";

const RootScene = React.memo(
  () => {
    const controller = useRef(new UIViewController()).current;

    useEffect(() => {
      /** TODO: move registration to another file when entities will be too much */
      ScenesViewModel.registerView(
        SceneControllerTranslationEdit,
        TranslationEditScene
      );
    }, []);

    return (
      <ScenesContext.Provider value={controller.scenes}>
        <SceneRender />
      </ScenesContext.Provider>
    );
  },
  () => true
);

export default RootScene;
